"use client";

import Link from "@/components/ui/Link";
import { getTimeAgo } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  date?: FieldConfig;
  title?: FieldConfig;
  excerpt?: FieldConfig;
  slug?: string;
};
export default function horizontalSideMostview({
  date = {
    hidden: false,
    value: "01",
    customClass: ""
  },
  title = {
    hidden: false,
    value: "சுவிஸ் மத்திய வங்கி உதவியை அறிவித்த பிறகு கிரெடிட் சூயிஸ்...",
    customClass: ""
  },
  excerpt = {
    hidden: false,
    value: "",
    customClass: ""
  },
  slug
}: Props) {
  const dateValue = getTimeAgo(date?.value);
  const titleValue = title?.value || "";
  const content = <div className="flex flex-col gap-3 p-4 bg-F8F8F8">
      {/* Date */}
      {!date?.hidden && <p className={`text-14-tamil-700 text-1B1B1B ${date?.customClass || ""}`}>{dateValue}</p>}

      {/* Title */}
      {!title?.hidden && <h3 className={`text-14-tamil-700 text-1B1B1B leading-[1.4] ${title?.customClass || ""}`}>
          {titleValue}
        </h3>}
    </div>;
  if (slug) {
    return <Link href={`/${slug}`} className="block hover:bg-gray-100 transition-colors cursor-pointer">
        {content}
      </Link>;
  }
  return content;
}